import { formRecordsOptions, getToken } from "helper/common";
import {
    CLEAR_LAB_RECORD_DETAILS,
    CLEAR_LAB_RECORD_LIST,
    SET_LAB_RECORD_DETAILS,
    SET_LAB_RECORD_LIST,
    LAB_RECORD_DETAILS_ERROR,
    LAB_RECORD_DETAILS_ERROR_CLEAR,
    LAB_RECORD_DETAILS_PENDING,
    LAB_RECORD_LIST_ERROR,
    LAB_RECORD_LIST_ERROR_CLEAR,
    LAB_RECORD_LIST_PENDING,
    LAB_RECORD_EDIT_ERROR_CLEAR,
    LAB_RECORD_EDIT_ERROR,
    LAB_RECORD_EDIT_PENDING,
    LAB_RECORD_EDIT_DIALOG_CLOSE,
    LAB_RECORD_EDIT_DIALOG_OPEN,
    LAB_RECORD_CREATE_ERROR_CLEAR,
    LAB_RECORD_CREATE_ERROR,
    LAB_RECORD_CREATE_PENDING,
    LAB_RECORD_CREATE_DIALOG_CLOSE,
    LAB_RECORD_CREATE_DIALOG_OPEN,
    SET_LAB_RECORDS_FILTER_DATA,
    LAB_RECORDS_FILTER_DIALOG_CLOSE,
    LAB_RECORDS_FILTER_DIALOG_OPEN,
} from "./constants";
import agent from "store/service/agent";
import { encodeObjectValues } from "helper/encodeData";
import { openSnackbar } from "store/slices/snackbar";
import { trimmedValues } from "helper/trim";

//-----------------------------|| LIST ||---------------------------------------------------------------
export const setLabRecordList = (labRecordList) => ({
    type: SET_LAB_RECORD_LIST,
    payload: { labRecordList }
});

export const clearLabRecordList = () => ({
    type: CLEAR_LAB_RECORD_LIST,
});

export const labRecordListPending = () => ({
    type: LAB_RECORD_LIST_PENDING
});

export const labRecordListError = (errorMessage) => ({
    type: LAB_RECORD_LIST_ERROR,
    payload: { errorMessage }
});

export const labRecordListErrorClear = () => ({
    type: LAB_RECORD_LIST_ERROR_CLEAR
});

export const getLabRecordList = (page, pageSize, sortOrder, sortDirection, filter) => (dispatch) => {
    const encodeFilters = encodeObjectValues({ ...filter });
    dispatch(labRecordListPending());
    return getToken(dispatch).then((accessToken) => {
        return agent.labRecords.getLabRecordList(accessToken, page, pageSize, sortOrder, sortDirection, encodeFilters)
            .then((labRecordList) => {
                dispatch(setLabRecordList(labRecordList));
                dispatch(labRecordListErrorClear());
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body.error.message;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(labRecordListError(message));
                }
                else {
                    dispatch(labRecordListError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}

//-----------------------------|| FILTER ||-------------------------------------------------------------
export const openLabRecordsFilterDialog = () => ({
    type: LAB_RECORDS_FILTER_DIALOG_OPEN
});

export const closeLabRecordsFilterDialog = () => ({
    type: LAB_RECORDS_FILTER_DIALOG_CLOSE
});

export const setLabRecordsFilteredData = (filter) => ({
    type: SET_LAB_RECORDS_FILTER_DATA,
    payload: { filter },
});

//-----------------------------|| DETAILS ||---------------------------------------------------------------
export const setLabRecordDetails = (labRecordDetails) => ({
    type: SET_LAB_RECORD_DETAILS,
    payload: { labRecordDetails }
});

export const clearLabRecordDetails = () => ({
    type: CLEAR_LAB_RECORD_DETAILS,
});

export const labRecordDetailsPending = () => ({
    type: LAB_RECORD_DETAILS_PENDING
});

export const labRecordDetailsError = (errorMessage) => ({
    type: LAB_RECORD_DETAILS_ERROR,
    payload: { errorMessage }
});

export const labRecordDetailsErrorClear = () => ({
    type: LAB_RECORD_DETAILS_ERROR_CLEAR
});

export const getLabRecordDetails = (id) => (dispatch) => {
    dispatch(labRecordDetailsPending());
    return getToken(dispatch).then((accessToken) => {
        return agent.labRecords.getLabRecordDetails(accessToken, id)
            .then((labRecordDetails) => {
                dispatch(setLabRecordDetails(labRecordDetails));
                dispatch(labRecordDetailsErrorClear());
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(labRecordDetailsError(message));
                }
                else {
                    dispatch(labRecordDetailsError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}

//-----------------------------|| CREATE ||---------------------------------------------------------------
export const openLabRecordCreateDialog = () => ({
    type: LAB_RECORD_CREATE_DIALOG_OPEN
});

export const closeLabRecordCreateDialog = () => ({
    type: LAB_RECORD_CREATE_DIALOG_CLOSE
});

export const labRecordCreatePending = () => ({
    type: LAB_RECORD_CREATE_PENDING
});

export const labRecordCreateError = (errorMessage) => ({
    type: LAB_RECORD_CREATE_ERROR,
    payload: { errorMessage }
});

export const labRecordCreateErrorClear = () => ({
    type: LAB_RECORD_CREATE_ERROR_CLEAR
});

export const labRecordCreate = (formData, filter, paginationData) => (dispatch) => {
    const { page, pageSize, sortOrder, sortDirection } = paginationData || {};
    const dataToSend = trimmedValues({ ...formData })
    dispatch(labRecordCreatePending());
    return getToken(dispatch).then((accessToken) => {
        return agent.labRecords.labRecordCreate(accessToken, dataToSend)
            .then(() => {
                dispatch(getLabRecordList(page, pageSize, sortOrder, sortDirection, filter));
                dispatch(labRecordCreateErrorClear());
                dispatch(closeLabRecordCreateDialog());
                dispatch(openSnackbar({
                    open: true,
                    message: 'Lab record successfully created.',
                    variant: 'alert',
                    close: false
                }))
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(labRecordCreateError(message));
                }
                else {
                    dispatch(labRecordCreateError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}

export const getFormRecordsOption = (filter) => (dispatch) => {
    return getToken(dispatch).then((accessToken) => {
        return agent.labRecords.getFormRecordsOption(accessToken, filter)
            .then((roles) => {
                const options = formRecordsOptions(roles['value']);
                return Promise.resolve(options);
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    console.err(message)
                }
                return Promise.reject();
            })
    })
}

//-----------------------------|| EDIT ||---------------------------------------------------------------
export const openLabRecordEditDialog = () => ({
    type: LAB_RECORD_EDIT_DIALOG_OPEN
});

export const closeLabRecordEditDialog = () => ({
    type: LAB_RECORD_EDIT_DIALOG_CLOSE
});

export const labRecordEditPending = () => ({
    type: LAB_RECORD_EDIT_PENDING
});

export const labRecordEditError = (errorMessage) => ({
    type: LAB_RECORD_EDIT_ERROR,
    payload: { errorMessage }
});

export const labRecordEditErrorClear = () => ({
    type: LAB_RECORD_EDIT_ERROR_CLEAR
});

export const labRecordEdit = (formData) => (dispatch) => {
    const dataToSend = trimmedValues({ ...formData })
    dispatch(labRecordEditPending());
    return getToken(dispatch).then((accessToken) => {
        return agent.labRecords.labRecordEdit(accessToken, dataToSend)
            .then(() => {
                dispatch(getLabRecordDetails(formData?.id));
                dispatch(labRecordEditErrorClear());
                dispatch(closeLabRecordEditDialog());
                dispatch(openSnackbar({
                    open: true,
                    message: 'Lab record details successfully updated.',
                    variant: 'alert',
                    close: false
                }))
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body.error?.message;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(labRecordEditError(message));
                }
                else {
                    dispatch(labRecordEditError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}
